import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=24d308db&"
import script from "./CertificatePage.vue?vue&type=script&lang=js&"
export * from "./CertificatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d308db')) {
      api.createRecord('24d308db', component.options)
    } else {
      api.reload('24d308db', component.options)
    }
    module.hot.accept("./CertificatePage.vue?vue&type=template&id=24d308db&", function () {
      api.rerender('24d308db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/CertificatePage.vue"
export default component.exports